import axios from 'axios';
import * as CONFIG from '../config/index';
import * as helper from './helper';

export const PERIOD_API_URL = `${CONFIG.API_URL}/period`;

export const search = async (condition, pageNo, pageSize, active) => {
  try {
    let res = await axios.get(
      `${PERIOD_API_URL}/search?condition=${condition}&pageNo=${pageNo}&pageSize=${pageSize}&active=${
        active ? active : false
      }`
    );
    return res.data.data;
  } catch (e) {
    helper.notifyError(e);
    return { totals: 0, items: [] };
  }
};

export const get = async id => {
  try {
    let res = await axios.get(`${PERIOD_API_URL}/${id}`);
    return res.data.data;
  } catch (e) {
    helper.notifyError(e);
  }
};

export const create = async form => {
  try {
    if (form.processDate) {
      form.processDate = form.processDate.getTime();
    }
    let res = await axios.post(PERIOD_API_URL, form);
    helper.successMsg('Thêm mới thành công');
    return res.data;
  } catch (e) {
    helper.notifyError(e);
  }
};

export const update = async form => {
  try {
    if (form.processDate) {
      form.processDate = form.processDate.getTime();
    }
    let res = await axios.put(PERIOD_API_URL, form);
    helper.successMsg('Cập nhật thành công');
    return res.data;
  } catch (e) {
    helper.notifyError(e);
  }
};

export const lock = async form => {
  try {
    let res = await axios.post(`${PERIOD_API_URL}/lock`, form);
    helper.successMsg('Cập nhật thành công');
  } catch (e) {
    helper.notifyError(e);
  }
};

export const complete = async form => {
  try {
    let res = await axios.post(`${PERIOD_API_URL}/complete`, form);
    helper.successMsg('Kết thúc chấm điểm thành công');
    return res.data;
  } catch (e) {
    helper.notifyError(e);
    return [];
  }
};
export const reScore = async code => {
  try {
    let res = await axios.post(`${PERIOD_API_URL}/re-score`, { code: code });
    helper.successMsg('Mở lại chấm điểm thành công');
    return res.data;
  } catch (e) {
    helper.notifyError(e);
    return [];
  }
};
export const deleteFoler = async form => {
  try {
    if (form.processDate) {
      form.processDate = form.processDate.getTime();
    }
    let res = await axios.put(`${PERIOD_API_URL}/delete-folder`, form);
    helper.successMsg('Xoá thành công');
    return res.data;
  } catch (e) {
    helper.notifyError(e);
  }
};
export default {
  search,
  create,
  update,
  get,
  lock,
  complete,
  reScore,
  deleteFoler
};



// WEBPACK FOOTER //
// ./src/common/period.js